module.exports = __webpack_public_path__ + "img/ticker-tape-one.62db2567.jpg";